import { polygon } from "@turf/helpers";
import mask from "@turf/mask";
import { union } from "@turf/turf";
import { useEffect, useState } from "react";

const sourceId = "polygonMask";

const usePolygonMask = () => {
  const [source, setSource] = useState<mapboxgl.GeoJSONSource | null>(null);
  const [geoData, setGeoData] = useState<mapboxgl.GeoJSONSource | null>(null);

  useEffect(() => {
    if (source && geoData?.features) {
      const initialPolygons = geoData.features?.flatMap((feature) => {
        const { type, coordinates } = feature.geometry;

        if (type === "Polygon") {
          return [polygon(coordinates)];
        }
        if (type === "MultiPolygon") {
          // For multipolygons, create a polygon for each part
          return coordinates.map((polygonCoords) => polygon(polygonCoords));
        }
      });
      let combinedPolygon = initialPolygons[0];

      for (let i = 1; i < initialPolygons.length; i++) {
        combinedPolygon = union(combinedPolygon, initialPolygons[i]);
      }

      const worldMask = polygon([
        [
          [-180, 90], // Top left
          [-180, -90], // Bottom left
          [180, -90], // Bottom right
          [180, 90], // Top right
          [-180, 90], // Back to start
        ],
      ]);

      const masked = combinedPolygon && mask(combinedPolygon, worldMask);

      source.setData({
        type: "FeatureCollection",
        features: masked ? [masked] : [],
      });
    } else if (source && !geoData) {
      source.setData({
        type: "FeatureCollection",
        features: [],
      });
    }
  }, [source, geoData]);

  const setLayer = (map: mapboxgl.Map) => {
    // After the map style has loaded on the page,
    // add a source layer and default styling for a single point
    map.on("load", () => {
      let s = map.getSource(sourceId);
      if (!s) {
        map.addSource(sourceId, {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: [],
          },
        });

        map.addLayer({
          id: "polygonMask",
          source: sourceId,
          type: "fill",
          paint: {
            // "fill-pattern": "YellowStripePattern",
            "fill-color": "white",
            "fill-outline-color": "white",
            "fill-opacity": 0.7,
          },
        });

        map.addLayer({
          id: "lineMask",
          source: sourceId,
          type: "line",
          paint: {
            "line-color": "#FFD061",
            "line-width": 3,
          },
        });

        s = map.getSource(sourceId);
      }

      // setTimeout(() => {
      //   if (!map) return;
        
      //   const polygonMaskLayer = map.getLayer('polygonMask');
      //   const lineMaskLayer = map.getLayer('lineMask');
      //   const municipalitiesLayer = map.getLayer('municipalities-germany-fine-outline');

      //   if (polygonMaskLayer && municipalitiesLayer) {
      //     map.moveLayer('polygonMask', 'municipalities-germany-fine-outline');
      //   }
      //   if (lineMaskLayer && municipalitiesLayer) {
      //     map.moveLayer('lineMask', 'municipalities-germany-fine-outline');
      //   }
      // }, 100);

      setSource(s);
    });
  };

  return [setLayer, setGeoData];
};

export default usePolygonMask;
